/**
 * Widget Service main js file
 *
 * @package Wordpress\sww
 * @since 1.0.0
 * @version 1.0.0
 */

'use strict';

/* global jQuery */
/* global swwapp */
jQuery(function ($) {
  swwapp.widgetService = {};

  /**
   * Find the button in the Widget Service
   *
   * @since 1.0.0
   * @return object The button in div.sww-widget-service
   */
  swwapp.widgetService.getButton = function () {
    var button = $('div.sww-widget-service').find('a.button');
    return button;
  };
  /**
   * Method to handle the button click
   *
   * @since 1.0.0
   */
  swwapp.widgetService.clickHandler = function (e) {
    e.preventDefault();

    //prevent doubleclick
    if (!e.currentTarget.clicked || e.currentTarget.clicked === false) {
      e.currentTarget.clicked = true;
    } else {
      return;
    }

    //animate the click
    if (!$('div.icon-card-textbox-slide').hasClass('open')) {
      $('div.icon-card-textbox-slide').animate({
        'top': '7em'
      }, 500);
      $('div.icon-card-textbox-slide div.icon-card').css('position', 'relative');
      $('div.icon-card-textbox-slide div.icon-card').animate({
        'height': '6em',
        'opacity': 1
      }, 1000, function () {
        $('div.icon-card-textbox-slide').addClass('open');
      });
    } else {
      $('div.icon-card-textbox-slide').animate({
        'top': '0em'
      }, 1000);
      $('div.icon-card-textbox-slide div.icon-card').animate({
        'height': '0em',
        'opacity': 0
      }, 500, function () {
        $('div.icon-card-textbox-slide div.icon-card').css('position', 'fixed');
        $('div.icon-card-textbox-slide').removeClass('open');
      });
    }
    console.log(e);
    e.currentTarget.clicked = false;
    return;
  };

  /**
   * Property to save the button object
   *
   * @since 1.0.0
   * @var object The button object from div.sww-widget-service
   */
  swwapp.widgetService.button = swwapp.widgetService.getButton();
  $(swwapp.widgetService.button).on('click', swwapp.widgetService.clickHandler);
});